module.exports = __webpack_public_path__ + "static/media/light-mode.9afb372c.svg";